<template>
  <div class="navbar">
    <nav class="nav-extended indigo darken-2">
      <div class="nav-content">
        <router-link :to="{name:'Welcome'}">
          <span class="nav-title " style="margin-left: 60px">Friendsfinder 2019</span>
        </router-link>
        <ul class="right">
          <span class="nav-title "><a @click="logout">Ausloggen</a></span>
        </ul>
        <ul class="right">
          <span class="nav-title "><a @click="messages">Messages</a></span>
        </ul>
        <ul class="right">
         <span class="nav-title "><a @click="online">Online</a></span>
        </ul>
        <ul class="right">
          <span class="nav-title "><a @click="chat">Chat</a></span>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
    import {getDestinationUser, getUser} from "../firebase/GlobalDBFunctions"
    export default {
        name: "Navbar",
        methods: {
            logout() {
                    this.$router.push({ name: 'Welcome' })
            },
            online() {
                this.$router.push({ name: 'Online',params:{name: getUser()}  })
            },
            chat() {
                this.$router.push({ name: 'Chat', params:{name: 'onlinechat'} })
            },
            messages() {
                this.$router.push({ name: 'UserMessage', params:{name: getUser(), neuePerson:getDestinationUser()} })
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue